import { Pipe, PipeTransform } from '@angular/core';
import {SystemHelpers} from '../helpers';

@Pipe({
  name: 'facultyTrans'
})
export class FacultyTransPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return SystemHelpers.facultyTrans(value);
  }

}
